import { watch, onBeforeUnmount } from 'vue'

export const useShowOverlayWhenNoRowsVisible = ({ gridApi }) => {
  let totalVisibleRows = 0

  const rowUpdatedListener = () => {
    totalVisibleRows = gridApi.value.getDisplayedRowCount()
    if (totalVisibleRows === 0) {
      gridApi.value.showNoRowsOverlay()
    } else {
      gridApi.value.hideOverlay()
    }
  }

  watch(
    gridApi,
    () => {
      gridApi.value.addEventListener('displayedRowsChanged', rowUpdatedListener)
    },
    {
      once: true
    }
  )

  onBeforeUnmount(() => {
    gridApi.value.removeEventListener('displayedRowsChanged', rowUpdatedListener)
  })
}
